export default "__VITE_ASSET__B$f4RqLw__"